import React, { Component} from 'react'
import { connect } from 'react-redux'
import {addPassword} from '../../../actions/user'
import {hideModal} from '../../../actions/modals'
import AddPasswordForm from '../../../components/forms/account/AddPasswordForm'
import errorMessages from '../../../errorMessages.js'
import {showNotification} from '../../../actions/notifications'



const responseGoogle = (response) => {}


class AddPasswordContainer extends Component {

	constructor(){
		super()
		this.addPassword=this.addPassword.bind(this) 
	}

	addPassword(googleUser){
		const authInstance=window.gapi.auth2.getAuthInstance()
		authInstance.signOut()
		//const email=this.props.form.values.email
		const newPassword=this.props.form.values.newPassword
		// const recaptchaResponse=this.props.form.values.recaptchaResponse
		const requestData={
			idToken:googleUser.tokenId,
			password:newPassword
		}


		this.props.addPassword(this.props.user.id,requestData).then((response) => {
			this.props.hideModal()
			const notificationMessage='email and password login to your account'
		 	this.props.showNotification(notificationMessage,'Added','default')
		})
			.catch(error => {
				this.props.hideModal()
				let errorMessage='Something went wrong. Unable to add email and password login.'
				if(errorMessages.accountErrors.addPassword[error.response.status]){
			 		errorMessage=`${errorMessages.accountErrors.addPassword[error.response.status]}`
				}
				this.props.showNotification(errorMessage,'Error','destroy')
			})



	}



	render() {
		return (
			<div className='addPassword'>
				<div className='addPassword-explainText'>
					Add a password to your Plickers account so you can always sign in with email and password, even if you lose access to your Google account.
					After adding a password, you will still be able to access Plickers via the Google Sign-in button.
				</div>

				<AddPasswordForm
					email={this.props.user.email}            
					responseGoogle={responseGoogle}
					addPassword={this.addPassword}
				/>

			</div>
		)
	}
}



export default connect(
	(state,ownProps) => ({
		user:state.user,
		idToken:state.modals.idToken,
		form:state.form.addPasswordForm,
		setBanner:state.modals.setBanner
	}),
	{addPassword,showNotification,hideModal}
)(AddPasswordContainer)


// WEBPACK FOOTER //
// ./src/containers/modals/account/AddPasswordContainer.js